import { GlobalService } from "../services/global";
import { aMinutesMillisecond } from "../varibles/constants";

interface EncryptedToken {
    value: ArrayBuffer
    iv: Uint8Array
    expiresAt: number
}

// Remove tokens persisted by older application versions.
localStorage.removeItem('barentsSwatch');

let encryptionKey: CryptoKey | undefined;
let encryptedToken: EncryptedToken | undefined;

async function saveToken(token: string, expiresIn: number) {
    encryptionKey = encryptionKey || await crypto.subtle.generateKey(
        { name: 'AES-GCM', length: 256 },
        false,
        ['encrypt', 'decrypt']
    );

    const iv = crypto.getRandomValues(new Uint8Array(12));
    const value = await crypto.subtle.encrypt(
        { name: 'AES-GCM', iv },
        encryptionKey,
        new TextEncoder().encode(token)
    );

    encryptedToken = {
        value,
        iv,
        expiresAt: Date.now() + expiresIn * 1000 - 15 * aMinutesMillisecond
    };
}

async function getSavedToken() {
    if (!encryptionKey || !encryptedToken || encryptedToken.expiresAt < Date.now()) {
        return '';
    }

    const value = await crypto.subtle.decrypt(
        { name: 'AES-GCM', iv: encryptedToken.iv },
        encryptionKey,
        encryptedToken.value
    );

    return new TextDecoder().decode(value);
}

async function getToken() {
    try {
        const authentication: any = await GlobalService.loginBrantSwatch()

        await saveToken(authentication.access_token, authentication.expires_in);

        return authentication.access_token;
    } catch (err) {
        console.error('Get data of BrantSwatch failed')
        return ''
    }
}

export default async function callApi(url: string, options?: any) {

    let token = '';
    try {
        token = await getSavedToken();
    } catch (error) {
        encryptedToken = undefined;
    }

    if (!token) {
        token = await getToken();
    }

    if (token.length === 0) {
        return;
    }

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": `Bearer ${token}`,

    }

    try {
        let response = await fetch(url, { method: 'GET', headers, ...options || {} });
        return await response.json();
    } catch (error) {
        throw error
    }
}
